module.exports = __webpack_public_path__ + "media/images/lb/653-20d9a2bf35f31294c5d65f6c990594e4.svg";